import { useState } from "react";
import { NavLink } from "react-router-dom";
import GorillianCanvas from "../util/GorillianCanvas";

export default function MainNav() {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((v) => !v);
  const close = () => setIsOpen(false);

  return (
    <div className={`main-nav-container ${isOpen ? "open" : ""}`}>
      <div className="brand-and-toggle">
        <NavLink
          to="/"
          className="main-nav link brand-link"
          onClick={close}
          aria-label="Home"
        >
          <GorillianCanvas
            className="mark"
            intensity={0.85}
            progress={1}
            logoScale={0.92}
            hoverTint={false}
          />
        </NavLink>
        <button
          type="button"
          className="nav-toggle"
          aria-label="Toggle navigation"
          aria-expanded={isOpen}
          onClick={toggle}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>
      </div>
      <div className="nav-links" role="navigation">
        <NavLink
          to="/about"
          className="main-nav link titleFont"
          onClick={close}
        >
          About
        </NavLink>
        <NavLink
          to="/current-focus"
          className="main-nav link titleFont"
          onClick={close}
        >
          Currently
        </NavLink>
        <NavLink
          to="/resume"
          className="main-nav link titleFont"
          onClick={close}
        >
          Resume
        </NavLink>
      </div>
    </div>
  );
}
